<template>
    <div class="some-share">
        <span v-if="label" class="label">{{ $t('dssomeshare.share') }}:</span>
        <button
            v-for="channel in channels"
            :key="`share-${channel.network}`"
            class="channel"
            @click="share(channel.network)"
        >
            <DSFontIcon :code="channel.icon" />
        </button>
    </div>
</template>
<script setup>
import { useShareLink } from 'vue3-social-sharing';
const { shareLink } = useShareLink();

const props = defineProps({
    label: {
        type: Boolean,
        required: false,
        default: false,
    },
    sharing: {
        type: Object,
        required: true,
    },
    channels: {
        type: Array,
        required: false,
        default: () => [
            { network: 'whatsapp', icon: 'whatsapp_black' },
            { network: 'facebook', icon: 'facebook_black' },
            { network: 'twitter', icon: 'x_logo' },
        ],
    },
});

const share = network => {
    shareLink({
        network,
        ...props.sharing,
    });
};
</script>
<script>
export default {
    name: 'SomeShare',
};
</script>
<style scoped>
.some-share {
  display: inline-flex;
  align-items: center;
  font-weight: 700;
}

.label {
  margin-right: 0.5rem;
}

.channel {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}
.channel:not(:last-child) {
  margin-right: 0.5rem;
}

a {
  margin-left: 0.5rem;
}
</style>
